import { gql } from 'graphql-request';

import withdrawPage from './withdrawPage';

const plusQuery3 = gql`query Plus3 {
  ${withdrawPage}
}`;

export default plusQuery3;
